import React from 'react'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import faqList from './faq-list'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#99f3bd',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#d2f6c5'
  }
}))(MuiAccordionDetails)

const FaqAccordion = () => {
  const [expanded, setExpanded] = React.useState('panel0')

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <div>
      {faqList.map((item, i) =>
        <Accordion
          key={i}
          square
          expanded={expanded === `panel${[i]}`}
          onChange={handleChange(`panel${[i]}`)}
        >
          <AccordionSummary
            aria-controls={`panel${[i]}d-content`}
            id={`panel${[i]}d-header`}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>{item.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {item.text}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  )
}

export default FaqAccordion
